<template>
    <page :tabs="tabs">
            <b-container fluid class="my-3">
                <owner-details-form @success-create="handleSuccessOwnerCreate"></owner-details-form>
            </b-container>
    </page>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Page from '../../generic/page/page.vue';
    import OwnerDetailsForm from '../common/owner-details-form.vue';

    export default {
        name: 'OwnerCreate',
        components: {
            Page,
            OwnerDetailsForm,
        },
        data() {
            return {
                tabs: [
                    {
                        title: `Owner List`,
                        route: `/app/owner/list/`,
                        active: false,
                    },
                    {
                        title: `Details`,
                        route: `/app/owner/create/`,
                        active: true,
                    },
                ],
            }
        },
        methods: {
            handleSuccessOwnerCreate(owner) {
                window.location = `/app/owner/${owner.id}/edit/`;
            }
        }
    }
</script>
